import { QUOTATIONS } from '../_constants';

const initialState = {
  quotationsList: {
    loading: false,
    data: []
  },
}

export function QuotationsReducer(state = initialState, action) {
  switch (action.type) {
    case QUOTATIONS.CLEAR:
      return initialState;
    default:
      return state
  }
}